import * as React from 'react';

import { Actions, ActionType } from './actions';
import { defaultState, store } from './store';
import { AppContextState } from './types';

const { Provider } = store;

function reducer(state = defaultState, action: Actions): AppContextState {
    switch (action.type) {
        case ActionType.SetIsLoading:
            return { ...state, isLoading: action.isLoading };
        default:
            return state;
    }
}

export function AppContextProvider(props: React.PropsWithChildren) {
    const [state, dispatch] = React.useReducer(reducer, { ...defaultState });

    return <Provider value={{ state, dispatch }}>{props.children}</Provider>;
};